<template>
	<div class="fundraising-new">
		<!-- BIG SLOGAN -->
		<div class="container">
			<h1 class="mb-30">{{ $t("project.yourCampaign") }}</h1>
			<p class="crowd-or-rais"><span class="domore-yellow">FUNDRAISING</span></p>
		</div><!-- .container -->
    <!-- ORGANIZATION -->
    <choose-organization :project='project' :errors='errors'></choose-organization>

    <!-- FORM -->
    <fundraising-form :project.sync='project' :submit='submit' :errors='errors' :alert='alert'></fundraising-form>

		<!-- STAR BOX -->
		<div class="container mt-50 mb-50">
			<p class="center"><img src="~assets/img/star.png"></p>
		</div><!-- .container .mt-50 .mb-50 -->
	</div>
</template>

<script>
// API
import projectsApi from '@/api/v1/projects';
// Components
import FundraisingForm from '@/views/Fundraising/Form';
import ChooseOrganization from '@/components/Project/Form/ChooseOrganization';
// Mixins
import alert from '@/mixins/alert';

export default {
  mixins: [alert],
  components: { FundraisingForm, ChooseOrganization },
  data() {
    return {
      project: {
        crowdfunding: false,
        category_id: '',
        country_id: '',
        organization_id: '',
        translation: { locale: localStorage.getItem('lang') },
        translations: [{ locale: localStorage.getItem('lang') }],
        video_url: '',
        photo: {},
      },
      submit: {
        action: this.saveProject,
        processing: false,
      },
    };
  },
  methods: {
    saveProject() {
      const vm = this;
      vm.clearAlerts();
      vm.submit.processing = true;
      // Set crowdfunding flag to false for fundraising projects
      vm.project.crowdfunding = false;
      const organization = vm.project.organization_id;
      vm.project.organization_id = organization || null;
      projectsApi.new(vm.project).then((response) => {
        vm.submit.processing = false;
        this.$set(this.project, 'id', response.data.id);
        this.project.translation = response.data.translations.find(t =>
          t.locale === this.project.translation.locale,
        );
        this.project.translations = response.data.translations;
        vm.alert.success = vm.$t('project.form.newProjectSuccessAlert');
      })
      .catch((response) => {
        vm.submit.processing = false;
        vm.project.organization_id = organization;
        vm.alert.error = vm.$t('errors.incorrectData');
        const errors = response.response.data;
        vm.errors = errors;
        if (response.response.data.organization && !organization) {
          vm.errors.my_organization = [vm.$t('project.form.organizationMissingError')];
        }
        window.scrollTo(0, 0);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?6bcc08b2